module.exports = __webpack_public_path__ + "fe1e6b2f234b93408bdfda30652f54b1.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CD.svg
// module id = ogxS
// module chunks = 0